import { useEffect, useRef } from "react"
import { createRoot } from "react-dom/client"

import { useMap } from "react-leaflet"
import L from "leaflet"

import { YoutubeSearchedForRounded } from "@mui/icons-material"

const ResetBoundsControl = ({ bounds, position = "topright" }) => {
  const map = useMap()
  const dirtyRef = useRef(false)

  const getPadding = (placement) => {
    let padding = [0, 0]
    const drawerEl = document.getElementById(`drawer-${placement}`)

    if (drawerEl) {
      const offset = drawerEl.style.visibility !== "hidden"
        ? drawerEl.offsetWidth
        : 0

      padding[0] = offset
    }
    return padding
  }

  useEffect(() => {
    if (!map) return

    const ControlClass = L.Control.extend({
      options: { position },
      onAdd: function () {
        const container = L.DomUtil.create(
          "div",
          "leaflet-control-reset leaflet-bar leaflet-control"
        )
        container.title = "Reset zoom"

        const link = L.DomUtil.create("a", "leaflet-disabled", container)

        const root = createRoot(link)
        root.render(<YoutubeSearchedForRounded fontSize="small" />)

        const markDirty = () => {
          dirtyRef.current = true
          link.classList.remove("leaflet-disabled")
        }

        map.on("moveend zoomend", markDirty)

        L.DomEvent.on(link, "click", (e) => {
          e.preventDefault()
          if (!dirtyRef.current) return

          // Reset dirty state and disable button immediately
          dirtyRef.current = false
          link.classList.add("leaflet-disabled")

          // Detach while the programmatic fitBounds animation runs,
          // then reattach once it settles (moveend always fires, even after zoom).
          map.off("moveend zoomend", markDirty)
          map.once("moveend", () => {
            map.on("moveend zoomend", markDirty)
          })

          map.fitBounds(bounds, {
            animate: true,
            paddingTopLeft: getPadding("left"),
            paddingBottomRight: getPadding("right"),
          })
        })

        return container
      }
    })

    const resetControl = new ControlClass()
    map.addControl(resetControl)

    return () => {
      map.removeControl(resetControl)
    }
  }, [map])

  return null
}

export default ResetBoundsControl